import { Badge, Rate, Tooltip, Alert, Spin, Divider, Row, Col, Card } from 'antd';
import * as React from 'react';

import { RoomList } from './search-results-room.view';
import { SearchResultItem } from 'src/app/bookings/search/results/search-result-item';
import { AccommodationSummaryView } from './search-results-accommodation-summary.view'
import * as uuid from 'uuid';

interface AccommodationCardProp {
	items: AccommodationSearchResult[];
	setBusy: (isBusy: boolean) => void;
	selection: { [unitIndex: string]: ResultSelection };
	onChangeSelection: (selectedRowKeys: string[] | number[], selectedRows: Object[]) => any;
	onChangeOptionalSelection: (selectedRowKeys: string[] | number[], selectedRows: Object[]) => any;
	taxEditor?: React.ReactNode;
}

export const AccommodationCard: React.SFC<AccommodationCardProp> = (props) => {
	const { items, setBusy, onChangeSelection, onChangeOptionalSelection, selection, children, taxEditor } = props;
	const [item] = items;

	const rooms: RoomSearchResult[] = items.reduce((prev, curr) => [
		...prev,
		...(curr.subProducts.length > 0 && curr.subProducts[0].productType === 5
			? curr.subProducts
			: [curr])
	], []);
	let minPrice: number;
	let minPriceCurrency: string;
	let minPriceProduct: string;
	for (const room of rooms) {
		for (const unit of Object.getOwnPropertyNames(room.sellPrice)) {
			const unitIndex = parseInt(unit);
			const price = room.sellPrice[unitIndex];
			if (minPrice === undefined || minPrice > price.totalPrice) {
				minPrice = price.totalPrice;
				minPriceProduct = `${room.product.name} (${room.features ? room.features.code : ''})`;
				minPriceCurrency = price.currencyIsoCode;
			}
		}
	}
	const extra = (
		<Badge count={rooms.length > 1 ? rooms.length : 0} style={{ right: '-15px', marginTop: '5px' }}>
			<Tooltip title={minPriceProduct}>
				{minPrice} {minPriceCurrency}
			</Tooltip>
		</Badge>
	);

	return (
		<SearchResultItem
			title={<React.Fragment>{item.product.name} <Rate disabled={true} key={uuid.v4()} defaultValue={item.rating} /></React.Fragment>}
			extra={extra}
			product={item.product}
			renderProductSummary={renderProductSummaryWrapper(setBusy)}//Este metodo retorna una funcion, esto lo tuve q hacer por el setBusy, preguntar que es?
		>
			<RoomList
				setBusy={setBusy}
				parent={item}
				items={rooms as any}
				onChangeSelection={onChangeSelection}
				onChangeOptionalSelection={onChangeOptionalSelection}
				selection={selection}
				taxEditor={taxEditor}
			>
				{children}
			</RoomList>
		</SearchResultItem>
	)
};

const renderProductSummaryWrapper = (setBusy: (isBusy: boolean) => any) => {
	return (productMap: ProductMap, product: ProductItem) => {
		return (
			<AccommodationSummaryView
				product={product}
				setBusy={setBusy}
				left={false}
				textWidth={400}
				picturesWidth={500}
				externalPadding={30}
				internalPadding={15}
				colSpan={2}
			/>
		)
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/search/results/search-results-accommodation.view.tsx